import { Component, signal } from '@angular/core';
import { KcButtonComponent } from '@kaspacom/ui-kit';

@Component({
  selector: 'kcc20-cookie-consent-banner',
  standalone: true,
  imports: [KcButtonComponent],
  templateUrl: './cookie-consent-banner.component.html',
  styleUrl: './cookie-consent-banner.component.scss',
})
export class CookieConsentBannerComponent {
  readonly visible = signal(localStorage.getItem('cookiesConsent') === null);

  accept(): void {
    localStorage.setItem('cookiesConsent', 'accepted');
    localStorage.setItem('strictlyNecessaryCookies', 'true');
    localStorage.setItem('additionalCookies', 'true');
    this.visible.set(false);
  }

  reject(): void {
    localStorage.setItem('cookiesConsent', 'accepted');
    localStorage.setItem('strictlyNecessaryCookies', 'true');
    localStorage.setItem('additionalCookies', 'false');
    this.visible.set(false);
  }
}
